<template>
  <v-text-field
    type="number"
    :disabled="disabled"
    :readonly="field.isReadOnly"
    v-bind:label="labelText"
    v-model="fieldValue"
    v-bind:min="field.validations.minVal"
    v-bind:max="field.validations.maxVal"
    :hint="field.observations"
    :error-messages="fieldErrors"
    @input="validator.document.fields.$each[index].value.$touch()"
    @blur="validator.document.fields.$each[index].value.$touch()"
  ></v-text-field>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    index: {
      type: Number,
    },
    ctIndex: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    labelText() {
      return `${this.field.title}${this.field.isRequired ? " *" : ""}`;
    },
    fieldValue: {
      // getter
      get: function () {
        var userDecSep = this.$store.getters["account/user"].MetricDecimalSep;
        var userThouSep = this.$store.getters["account/user"].MetricThousandSep;
        return this.field.value
          .replaceAll(userThouSep, "")
          .replaceAll(userDecSep, ".");
      },
      // setter
      set: function (newValue) {
        var userDecSep = this.$store.getters["account/user"].MetricDecimalSep;
        this.field.value = newValue.replaceAll(".", userDecSep);
      },
    },
    fieldErrors() {
      const errors = [];
      if (this.validator.document) {
        if (!this.validator.document.fields.$each[this.index].value.$dirty)
          return errors;

        !this.validator.document.fields.$each[this.index].value.required &&
          errors.push(this.$t("RequiredField"));
      } else if (this.validator.contentTypeList) {
        if (
          !this.validator.contentTypeList.$each[this.ctIndex].document.fields
            .$each[this.index].value.$dirty
        )
          return errors;

        !this.validator.contentTypeList.$each[this.ctIndex].document.fields
          .$each[this.index].value.required &&
          errors.push(this.$t("RequiredField"));
      }

      return errors;
    },
  },
};
</script>